import { createContext } from 'react';

export const RestorePasswordContext = createContext(null);

RestorePasswordContext.displayName = 'RestorePasswordContext';
